module.exports = __webpack_public_path__ + "img/4200.3559619d.jpg";